// import React from "react";
// import { Link } from "react-router-dom";
// import {
//   Container,
// //   Row,
// //   Col,
// //   Form,
// //   Button,
  
// } from "react-bootstrap";
// // import "./TMASection.css";

// const services = [
//   {
//     title: "Industrial Entrepreneur Memorandum (IEM)",
//     link: "/dgft/iem",
//   },
//   {
//     title: "RCMCs (Registration Cum Membership Certificate)",
//     link: "/dgft/rcmc",
//   },
//   {
//     title: "DGFT Digital Signature (E-Token)",
//     link: "/dgft/token",
//   },
//   {
//     title: "Transport And Marketing Assistance (TMA)",
//     link: "/dgft/tma",
//   },
//   {
//     title: "Steel Import Monitoring System",
//     link: "/dgft/sims",
//   },
//   {
//     title: "Coal Import Monitoring System",
//     link: "/dgft/cims",
//     },
//     {
//         title: "Chip Import Monitoring System",
//         link:"/dgft/chip",
//     },
//     {
//         title: "Copper/Aluminium Import Monitoring System",
//         link:"/dgft/caims",
//   },
//     {
//       title: "Certificate Of Origin",
//       link:"/dgft/coo",
//     },
//     {
//         title: "Paper Import Monitoring System",
//         link:"/dgft/pims",
//     }
// ];

// export default function TMASection() {
//   return (
//       <section className="tma-section">
//           <Container>
//       <div className="container">

//         <h1 className="tma-title">
//           TRANSPORT AND MARKETING ASSISTANCE SCHEME (TMA)
//         </h1>

//         <div className="tma-grid">
//           {services.map((item, index) => (
//             <Link to={item.link} className="tma-card" key={index}>
//               <h4>{item.title}</h4>
//             </Link>
//           ))}
//         </div>

//               </div>
//         </Container>
//     </section>
//   );
// }


import React from "react";
import { Container } from "react-bootstrap";
import {
  // FaTruck,
  FaIndustry,
  FaFire,
  FaCoins,
  FaMicrochip,
  FaGlobe,
  FaCheckCircle
} from "react-icons/fa";

export default function OtherServices() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TMA */}
          <h1>
             Transport and Marketing Assistance (TMA)
          </h1>

          <p>
            The TMA scheme provides financial assistance to exporters for
            international freight and marketing of agricultural products.
            It aims to enhance export competitiveness and support agricultural trade.
          </p>

          <ul className="custom-list">
            <li><FaCheckCircle /> Reimbursement of transport costs</li>
            <li><FaCheckCircle /> Boosts export competitiveness</li>
            <li><FaCheckCircle /> Supports agriculture exporters</li>
          </ul>

          <p><strong>Our Services:</strong></p>
          <ul className="custom-list">
            <li><FaCheckCircle /> Eligibility assessment</li>
            <li><FaCheckCircle /> Application filing</li>
            <li><FaCheckCircle /> Claim documentation & follow-up</li>
          </ul>

          {/* SIMS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Steel Import Monitoring System (SIMS)
          </h2>

          <p>
            SIMS is a mandatory reporting system introduced by DGFT for importers
            of steel products. It ensures transparency and enables real-time
            monitoring of steel imports before shipment.
          </p>

          <ul className="custom-list">
            <li><FaCheckCircle /> Advance import registration</li>
            <li><FaCheckCircle /> Real-time monitoring by DGFT</li>
            <li><FaCheckCircle /> Mandatory before shipment</li>
          </ul>

          <p><strong>Our Services:</strong></p>
          <ul className="custom-list">
            <li><FaCheckCircle /> SIMS registration</li>
            <li><FaCheckCircle /> Data filing & compliance</li>
            <li><FaCheckCircle /> Error correction & support</li>
          </ul>

          {/* COAL */}
          <h2 className="section-title">
            <FaFire className="icon" /> Coal Import Monitoring System
          </h2>

          <p>
            This system monitors coal imports to ensure compliance with
            government policies and maintain transparency in trade activities.
          </p>

          <ul className="custom-list">
            <li><FaCheckCircle /> Mandatory prior registration</li>
            <li><FaCheckCircle /> Covers multiple coal categories</li>
            <li><FaCheckCircle /> Enables policy monitoring</li>
          </ul>

          <p><strong>Our Services:</strong></p>
          <ul className="custom-list">
            <li><FaCheckCircle /> Registration assistance</li>
            <li><FaCheckCircle /> Filing and documentation</li>
            <li><FaCheckCircle /> Compliance guidance</li>
          </ul>

          {/* COPPER */}
          <h2 className="section-title">
            <FaCoins className="icon" /> Copper / Aluminium Import Monitoring
          </h2>

          <p>
            A monitoring system for non-ferrous metal imports such as copper
            and aluminium to regulate trade and maintain import data accuracy.
          </p>

          <ul className="custom-list">
            <li><FaCheckCircle /> Mandatory import data reporting</li>
            <li><FaCheckCircle /> Pre-import compliance requirement</li>
            <li><FaCheckCircle /> Supports trade regulation</li>
          </ul>

          <p><strong>Our Services:</strong></p>
          <ul className="custom-list">
            <li><FaCheckCircle /> Application filing</li>
            <li><FaCheckCircle /> Documentation support</li>
            <li><FaCheckCircle /> Compliance assistance</li>
          </ul>

          {/* CHIP */}
          <h2 className="section-title">
            <FaMicrochip className="icon" /> Chip Import Monitoring System
          </h2>

          <p>
            This system is introduced to monitor imports of electronic components
            and semiconductor-related items, ensuring transparency and proper
            tracking of imports.
          </p>

          <ul className="custom-list">
            <li><FaCheckCircle /> Advance import registration</li>
            <li><FaCheckCircle /> Covers electronic goods</li>
            <li><FaCheckCircle /> Ensures transparency in imports</li>
          </ul>

          <p><strong>Our Services:</strong></p>
          <ul className="custom-list">
            <li><FaCheckCircle /> Registration & filing</li>
            <li><FaCheckCircle /> Product classification support</li>
            <li><FaCheckCircle /> End-to-end compliance</li>
          </ul>

          {/* COO */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Certificate of Origin (COO)
          </h2>

          <p>
            Certificate of Origin (COO) certifies that exported goods are
            manufactured in India. It is essential for customs clearance and
            helps exporters claim duty benefits under trade agreements.
          </p>

          <ul className="custom-list">
            <li><FaCheckCircle /> Required for customs clearance</li>
            <li><FaCheckCircle /> Helps claim duty benefits</li>
            <li><FaCheckCircle /> Essential export document</li>
          </ul>

          <p><strong>Our Services:</strong></p>
          <ul className="custom-list">
            <li><FaCheckCircle /> COO application filing</li>
            <li><FaCheckCircle /> Documentation verification</li>
            <li><FaCheckCircle /> DGFT portal assistance</li>
          </ul>

        </Container>
      </section>
    </div>
  );
}